import { useMutation } from '@apollo/client';
import { useSnackbar } from '@upheal/design-system/vendor/notistack';
import { captureException } from '@upheal/shared/utils/sentry';
import { CheckoutDocument } from '@upheal/graphql/definitions/billing/Checkout.generated';

export const useCheckout = () => {
    const [checkoutMutation, { loading }] = useMutation(CheckoutDocument);
    const { enqueueSnackbar } = useSnackbar();

    const createCheckoutSession = async (
        planId: string,
        quantity: number = 1,
    ): Promise<string | undefined> => {
        const handleError = (context: object, errorTrackingMessage: string) => {
            captureException(`[billing] ${errorTrackingMessage}`, {
                ...context,
                planId,
                quantity,
            });
            enqueueSnackbar('Unknown error occurred. We are looking into it.', {
                variant: 'error',
            });
        };

        try {
            const response = await checkoutMutation({
                variables: { input: { planId, quantity } },
            });

            if (!response.data?.checkout?.url) {
                handleError(
                    { data: response },
                    'Checkout mutation returned no data',
                );

                return;
            }

            return response.data.checkout.url;
        } catch (error) {
            handleError({ error }, 'Checkout mutation failed');

            return;
        }
    };

    return {
        createCheckoutSession,
        loading,
    };
};
